import { BaseClient } from "./baseClient";
import { IDocumentApi } from "./document-v2";

export class DocumentApi extends BaseClient implements IDocumentApi {
  constructor() {
    super(
      new Headers({
        "Content-type": "application/json",
      }),
      process.env.REACT_APP_DOCUMENT_API_ENDPOINT as string
    );
  }

  uploadDocument = (locationHeader: string, file: File) => {
    const body = new FormData();
    body.append("document", file);

    return fetch(locationHeader, {
      credentials: "include",
      body,
      method: "POST",
    }).then((response: Response) => this.handleResponse("documenten", response));
  };

  updateDocument = (id: string, file: File, redenId: string) => {
    const body = new FormData();
    body.append("document", file);

    return fetch(`${this._apiEndpoint}/documenten/${id}`, {
      credentials: "include",
      headers: new Headers({
        "x-reason": redenId,
      }),
      body,
      method: "PUT",
    }).then((response: Response) => this.handleResponse("documenten", response));
  };

  depubliceerSession = async (id: string, redenId: string) => {
    return await this.api<Document>("documenten", id, "DELETE", undefined, undefined, undefined, [
      { key: "x-reason", value: redenId },
    ]);
  };
}
